import script from "./RewardDefaultsQuery.vue?vue&type=script&lang=js"
export * from "./RewardDefaultsQuery.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__